export default {
    RECEIVE_ZONES_OF_HARBOUR: 'RECEIVE_ZONES_OF_HARBOUR',
    RECEIVE_ZONE_OF_HARBOUR: 'RECEIVE_ZONE_OF_HARBOUR',
    DELETE_ZONE_OF_HARBOUR: 'DELETE_ZONE_OF_HARBOUR',

    // Types
    ZONE: 'zone',
    PLACE: 'place',
};
